module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dxdy"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_c('van-image', {
    attrs: {
      "width": "100",
      "src": require('@/page/dxdy/logo.png')
    }
  })], 1), _vm._v(" "), (_vm.isSubmit) ? _c('div', {
    staticStyle: {
      "margin-top": "25%",
      "text-align": "center",
      "line-height": "30px"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.splitUrlParam && _vm.splitUrlParam.status === '0' ? '确认退订消息？' : '确定重新订阅消息？'))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.splitUrlParam && _vm.splitUrlParam.status === '0' ? '退订后，您将不会收到该类别消息！' : '订阅后，您可继续收到该类别消息！'))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "loading": _vm.loading,
      "type": "info",
      "loading-text": "提交中...",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.submitHandle
    }
  }, [_vm._v(_vm._s(_vm.splitUrlParam && _vm.splitUrlParam.status === '0' ? '确定退订' : '确定订阅'))])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isSubmit) ? _c('div', {
    staticStyle: {
      "margin-top": "10%",
      "text-align": "center",
      "line-height": "30px"
    }
  }, [(_vm.isSuccess) ? _c('div', [_c('h1', [_vm._v("消息" + _vm._s(_vm.splitUrlParam && _vm.splitUrlParam.status === '0' ? '退订成功' : '订阅成功')), _c('van-icon', {
    staticStyle: {
      "margin-left": "5px",
      "vertical-align": "-2px"
    },
    attrs: {
      "name": "passed",
      "size": "28",
      "color": "#28d328"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.splitUrlParam && _vm.splitUrlParam.status === '0' ? '稍后您会收到退订成功短信' : '稍后您会收到订阅成功短信'))]), _vm._v(" "), _c('div', [_vm._v("请注意查收！")])]) : _c('div', [_c('h1', [_vm._v("消息" + _vm._s(_vm.splitUrlParam && _vm.splitUrlParam.status === '0' ? '退订失败' : '订阅失败'))]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("建议您稍后重试或者联系客服")]), _vm._v(" "), _c('div', [_vm._v("4008-889-889")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51af8f65"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/dxdy/dxdy.vue
// module id = 890
// module chunks = 2